
import React, { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from "react-router-dom";

import { IntegrationsConfig, Platform } from '@vromo/models/Integration';
import FontAwesome from '@vromo/ui/components/FontAwesome';
import { dataTestId } from '@vromo/models';
import { isNil, sortBy } from 'lodash';
import { LocationRow } from './LocationRow';
import Table from '@vromo/ui/components/Table';
import { useIntegrationsActions, useIntegrationsPage } from '../hooks';


/** a simple wrapper to render the integraion locations */
const Wrapper: FC = ({ children }) => <>
    <div style={{ display: 'flex', alignItems: 'center' }}>
        <FontAwesome icon="building" style={{ marginRight: 10 }} />
        <h3>{`Locations`}</h3>
    </div>

    <div style={{ display: 'flex', alignItems: 'center' }}>
        {children}
    </div>

</>


interface IntegrationLocationsProps {
    required: boolean;
    /** experimental */
    forceFetch?: boolean
}




export const IntegrationLocations = observer<IntegrationLocationsProps>(({ forceFetch, required = false }) => {

    const { queryLocations } = useIntegrationsActions()
    const { fetchedIntegrations, fetched } = useIntegrationsPage()
    const { platform } = useParams<{ platform: Platform }>()
    const instance = fetchedIntegrations.get(platform)

    // fetch integration available locations, if needed
    useEffect(() => {
        if (
            required && (
                (

                    instance?.completed && fetched &&
                    !instance.ext_locations?.length &&
                    instance?.features?.locations
                ) ||
                (
                    forceFetch &&
                    instance?.features?.locations
                )
            )
        )
            queryLocations(platform, "list")

    }, [instance, fetched, forceFetch])




    if (!instance?.completed || !required)
        return null

    if (
        !instance?.ext_locations ||
        (instance?.ext_locations && instance.ext_locations.length < 1)
    )
        return (
            <Wrapper>
                There are no locations to be configured.
            </Wrapper>)

    return (
        <Wrapper>
            <Table data-testid={dataTestId.integration.locations}>
                <thead>
                    <tr>
                        <th>Enabled</th>
                        <th>Name</th>
                        <th>Reference</th>
                        <th>Source Status</th>
                    </tr>
                </thead>
                <tbody>
                    {sortBy(instance?.ext_locations, ({ ext_title }) => ext_title)
                        .filter(location => location.ext_active)
                        .map((location, index) => (
                            <LocationRow
                                key={`integration-location-${index}`}
                                edit={!isNil(instance?.features?.editLocation)}
                                location={location}
                            />
                        ))}
                </tbody>
                <tfoot >
                    <tr>
                        <td colSpan={4} style={{ textAlign: 'right', opacity: '0.5' }}>
                            <i>* Matching Vromo sites will use "external id= {platform}_[reference]"</i>
                        </td>
                    </tr>
                </tfoot>
            </Table>
        </Wrapper>
    )
})
